import { render } from "./side-menu.vue?vue&type=template&id=4999a51a&scoped=true&ts=true"
import script from "./side-menu.ts?vue&type=script&scoped=true&lang=ts"
export * from "./side-menu.ts?vue&type=script&scoped=true&lang=ts"

import "./side-menu.vue?vue&type=style&index=0&id=4999a51a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4999a51a"]])

export default __exports__